module.exports = __webpack_public_path__ + "static/img/2.00d54e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/2.png
// module id = +8xL
// module chunks = 0